module.exports = __webpack_public_path__ + "static/img/20019 (4).e642338.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20019 (4).webp
// module id = iH2M
// module chunks = 14